export default __webpack_public_path__ + "static/media/convenio-line.1caf8c52.svg";